import { colors } from 'modules/app/styles'
import { Table } from 'reactstrap'
import styled from 'styled-components'
export const ShowList = styled.a`
  display: inline-block;
  position: absolute;
  right: 0;
  bottom: -32px;
  z-index: 1;
  background: #fff;
  padding: 7px 10px;
  border-radius: 15px;
  line-height: 1;
  @media (min-width: 922px) {
    display: none;
  }
`
export const TabContent = styled.div`
  width: 100%;
  flex-direction: column;
  overflow-y: auto;
  height: 90vh;
  @media (max-width: 576px) {
    height: 80vh;
  }
  @media (max-width: 991px) {
    display: none;
    &.hideTemplateList {
      display: flex;
    }
  }
  @media (min-width: 992px) {
    width: calc(100% - 255px);
    display: flex;
  }
`
export const SettingsTabs = styled.div`
  width: 100%;
  @media (max-width: 991px) {
    display: flex;
    &.hideTemplateList {
      display: none;
    }
  }
  @media (min-width: 992px) {
    width: 280px;
    display: flex;
    margin-left: auto;
  }
  flex-direction: column;
  padding-top: 50px;
  border-left: 1px solid ${colors['light-blue-200']};
  height: 90vh;
  overflow: auto;
  .title {
    padding: 0 24px;
    font-size: 18px;
    font-weight: 600;
  }
`

export const SettingItems = styled.ul`
  margin: 0;
  margin-top: 16px;
  margin-bottom: 40px;
  li {
    position: relative;
    a {
      position: relative;
      padding: 12px 24px;
      display: flex;
      align-items: center;
      cursor: pointer;
      span {
        padding: 0 8px;
      }
      &:hover {
        font-weight: 600;
        color: ${colors['main-text']};
      }
      svg {
        height: 18px;
        width: 18px;
      }
    }
    &:before {
      content: '';
      left: 0;
      right: 0;
      top: -4px;
      bottom: -4px;
      position: absolute;
    }
    &.active {
      a {
        font-weight: ${props => props?.boldActive ? '600' : '400'};
      }
      &:before {
        background: ${colors['lightest-blue']};
        border-left: 4px solid ${colors['main-blue']};
      }
    }
  }
`

export const IntegrationBox = styled.div`
  padding: 24px 0;
  border: 1px solid ${colors['light-blue-200']};
  background: ${colors['lightest-blue']};
  display: flex;
  align-items: center;
  flex-direction: column;
  @media (min-width: 576px) {
    flex-direction: row;
  }
  height: 100%;
  .logo {
    min-width: 140px;
    max-width: 140px;
    height: 120px;
    display: flex;
    justify-content: center;
    align-items: center;
    @media (min-width: 576px) {
      border-right: 1px solid ${colors['light-blue-200']};
    }
    svg {
      width: 100px;
    }
    &.zoom svg {
      width: auto;
    }
  }
  .content {
    padding: 0 24px;
    display: flex;
    flex-direction: column;
    align-items: center;
    @media (min-width: 576px) {
      align-items: unset;
    }
    .integration-name {
      font-size: 1.14rem;
      font-weight: 600;
      margin-bottom: 1.14rem;
    }
    .description {
      font-size: 1rem;
      margin-bottom: 1.14rem;
      text-align: center;
      min-height: 80px;
      @media (min-width: 576px) {
        text-align: unset;
      }
    }
  }
  a.slack-button,
  a.zoom-button {
    align-items: center;
    color: #000;
    background-color: #fff;
    border: 1px solid #ddd;
    border-radius: 48px;
    display: inline-flex;
    font-family: Lato, sans-serif;
    font-weight: 600;
    justify-content: center;
    text-decoration: none;
    svg {
      height: 22px;
      width: 22px;
      margin-right: 8px;
    }
  }
`

export const Badge = styled.span``
export const RemoveInviteEmail = styled.a`
  position: absolute;
  bottom: 12px;
  right: 0;
  background: #fff;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
  svg {
    width: 20px;
    height: 20px;
  }
`

export const ResumeplanMemberList = styled(Table)`
  margin-top: 8px;
`

export const MoveToFreeOption = styled.div`
  padding: 16px;
  background: ${colors['lightest-blue']};
  border: 1px solid ${colors['light-blue-200']};
  -webkit-text-fill-color: ${colors['text-secondary']};
  color: ${colors['text-secondary']};
  cursor: pointer;
  display: flex;
  align-items: center;
  .radio {
    min-width: 18px;
    max-width: 18px;
    height: 18px;
    border: 1px solid #c8d1e6;
    border-radius: 18px;
  }
  &:hover,
  &.active {
    border-color: ${colors['main-blue']};
    color: ${colors['main-text']};
  }
  &.active {
    .radio {
      border: 6px solid ${colors['main-blue']};
    }
  }
`
